/**
 * Admin Panel Page
 *
 * Control panel for super-admins and admins:
 * - User management (create, edit, delete, force MFA)
 * - Audit logs viewer
 * - System statistics
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import UserManagementTable from '../components/admin/UserManagementTable';
import { Shield } from 'lucide-react';

export default function AdminPanel() {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="min-h-screen bg-off-white">
      <div className="container mx-auto px-4 py-8">
        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <div className="p-3 bg-primary rounded-lg">
            <Shield size={32} className="text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-dark">Admin Panel</h1>
            <p className="text-gray-600">Manage users, roles, and system settings</p>
          </div>
        </div>

        {/* User Management */}
        <UserManagementTable />
      </div>
    </div>
  );
}
